import { Box, Button, Container, Paper, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

type FormSubmittedSplashPageProps = {
  formName: string;
  agentType?: string;
};

const FormSubmittedSplashPage: React.FC<FormSubmittedSplashPageProps> = ({ formName, agentType }) => {
  const navigate = useNavigate();
  if (formName === "Agent Intake" && agentType && agentType === "new") {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            backgroundColor: "#ffffff",
            borderRadius: 2,
            border: "2px solid #000",
            boxShadow: "none",
          }}
        >
          <Typography variant="h2" textAlign={"center"} paddingBottom={4}>
            Form Successfully Submitted
          </Typography>

          <Box
            sx={{
              backgroundColor: "rgba(0, 200, 0, .33)",
              border: "2px solid rgb(0, 200, 0)",
              borderRadius: 2,
              padding: 2,
              marginBottom: 2,
            }}
          >
            <Typography variant="body1">
              Your {formName} form has successfully been submitted. Please click the button below to go to the ACH Form
              to fill out your information to receive commissions.
            </Typography>
            <Box textAlign={"center"} paddingTop={2}>
              <Button type="button" onClick={() => navigate("/forms/achAgreement")} variant="contained">
                ACH Form
              </Button>
            </Box>
          </Box>
        </Paper>
      </Container>
    );
  } else {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            backgroundColor: "#ffffff",
            borderRadius: 2,
            border: "2px solid #000",
            boxShadow: "none",
          }}
        >
          <Typography variant="h2" textAlign={"center"} paddingBottom={4}>
            Form Successfully Submitted
          </Typography>

          <Box
            sx={{
              backgroundColor: "rgba(0, 200, 0, .33)",
              border: "2px solid rgb(0, 200, 0)",
              borderRadius: 2,
              padding: 2,
              marginBottom: 2,
            }}
          >
            <Typography variant="body1">Your {formName} has successfully been submitted.</Typography>
          </Box>
        </Paper>
      </Container>
    );
  }
};

export default FormSubmittedSplashPage;
